import { Badge, ListboxOption, SelectOption, spacingHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { mapBadgeVariant } from '../app-kit/helpers/mapBadgeVariant';
import { SelectOptionWithBadge } from '../types';
import { LabelBadge } from '../components/LabelBadge/LabelBadge';

const StyledListBoxOption = styled(ListboxOption)`
  & > div {
    display: flex;

    &:last-child {
      overflow: unset;
    }
  }
`;
const CalloutBadge = styled(Badge)`
  margin: ${spacingHelper('0 0 0 extraSmall')};
  align-self: center;
  height: ${spacingHelper('medium')};
`;
export const mapSelectOptionsWithBadgeToListNode = (
  selectOptionsWithBadge: SelectOptionWithBadge[],
) => {
  // eslint-disable-next-line react/display-name
  return ({ isActive, option }: { option: SelectOption; isActive: boolean }) => {
    const match = selectOptionsWithBadge.find((item) => item.value === option.value);
    return match ? (
      <StyledListBoxOption isActive={isActive} sizeVariant="small">
        <LabelBadge badgeVariant={match.badge} title={match.label} />
        {match.callout && (
          <CalloutBadge variant={mapBadgeVariant(match.callout.variant)} sizeVariant="extraSmall">
            {match.callout.text}
          </CalloutBadge>
        )}
      </StyledListBoxOption>
    ) : (
      <div />
    );
  };
};
